import type { EpbButtonColor } from '../shared/epb-button/epb-button.types'
import {
  HiddenElementsAction,
  PinProductAction,
  QueryRankingElementRankingAction,
} from '@empathyco/playboard-core-domain'

export const queryRankingActionConfigs: Record<string, { color: EpbButtonColor; icon: string }> = {
  [QueryRankingElementRankingAction.BOOST]: {
    color: 'green',
    icon: 'arrowup',
  },
  [QueryRankingElementRankingAction.BURY]: {
    color: 'red',
    icon: 'arrowdown',
  },
  [PinProductAction]: {
    color: 'yellow',
    icon: 'pin',
  },
  [HiddenElementsAction]: {
    color: 'default',
    icon: 'hide',
  },
}
